<template>
  <div class="memories">
    <ErrorBoundary :fall-back="fallBack">
      <hero :data="hero" :has-info="hasInfo"></hero>
    </ErrorBoundary>

    <ErrorBoundary :fall-back="fallBack">
      <info-block :data="info" v-if="hasInfo" />
    </ErrorBoundary>

    <div class="container">
      <div class="align-center">
        <ErrorBoundary :fall-back="fallBack">
          <MemoryButton :donation-options="donationOptions" class="mt-2" v-if="hasInfo && showMemoryFormBtn" />
        </ErrorBoundary>
      </div>

      <MemoryForm :page="page" class="mb-3" />

      <ErrorBoundary :fall-back="fallBack">
        <div class="container--block align-center">
          <h3 class="color__text--primary">{{cause.summary}}</h3>
          <p class="m-1 description__text" v-html="cause.description"></p>
        </div>
      </ErrorBoundary>

      <hr class="hr--blue hr--small my-4">

      <ErrorBoundary :fall-back="fallBack">
        <List :data="memories" kind="memory" type="items" />
      </ErrorBoundary>

      <div class="align-center mt-2 mb-2">
        <pulse-loader color="#A19378" :loading="busy"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Fallback from '../components/common/Fallback';
  import Hero from '../components/Hero';
  import MemoryButton from '../components/common/MemoryButton';
  import MemoryForm from '../components/forms/MemoryForm';
  import InfoBlock from '../components/common/InfoBlock';
  import List from '../components/main/List';
  import { EventBus } from '../eventbus';
  import { mapState } from 'vuex';
  import { log } from '../utilities/log';
  import { ErrorBoundary } from 'vue-error-boundary';
  import convertEmbedMedia from '../mixins/convertEmbedMedia';
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

  export default {
    name: 'Memories',

    mixins: [
      convertEmbedMedia
    ],

    components: {
      ErrorBoundary,
      Hero,
      MemoryButton,
      MemoryForm,
      PulseLoader,
      InfoBlock,
      List
    },

    data: () => {
      return {
        busy: false,
        fallBack: Fallback,
        haveAllMemories: false,
        page: 1,
        showMemoryFormBtn: true
      }
    },

    computed: {
      ...mapState({
        causes: state => state.causes,
        content: state => state.content,
        memories: state => state.memories
      }),
      cause: function () {
        return this.causes.filter((cause) => cause.id === this.$route.params.cause_id)[0];
      },
      donationOptions: function() {
        return this.cause.amounts;
      },
      videoURL: function() {
        let url = this.convertEmbedMedia(this.cause.video_url);
        return (url !== null) ? url : null;
      },
      hero: function () {
        return {
          type: 'memory',
          background: this.content.background,
          icon: this.cause.raisesouls_icon_url,
          title: this.cause.name
        }
      },
      info: function() {
        return {
          type: 'stream', //statement, stream
          video: this.videoURL
        }
      },
      hasInfo: function() {
        return (this.videoURL !== null || true);
      },
    },

    beforeMount: async function () {
      try {
        await this.$store.dispatch('updateMemories', { cause_id: this.$route.params.cause_id }, { root: true });
      } catch (err) { log(`Error Mounting Initial Memories: ${err.message}`, 'error'); }
    },

    mounted: function () {
      EventBus.$on('memory-form-toggle', (toggleMemoryFormBtn) => {
        this.showMemoryFormBtn = !toggleMemoryFormBtn;
      });

      EventBus.$on('have-all-memories', (bool) => {
        this.haveAllMemories = bool;
      });

      window.addEventListener('scroll', this.getMemories);
    },

    destroyed: function() {
      window.removeEventListener('scroll', this.getMemories);
    },

    methods: {
      getMemories: async function() {
        try {
          const footer = document.getElementById('footer').getClientRects()[0].height - 50;
          const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > (document.documentElement.offsetHeight - footer);

          if(bottomOfWindow && !this.busy && !this.haveAllMemories) {
            this.busy = true;
            this.page = this.page + 1;
            await this.$store.dispatch('updateMemoriesEndless', { cause_id: this.$route.params.cause_id, page: this.page }, { root: true });
            this.busy = false;
          }
        } catch(err) {
          log(`Error Setting Endless Memories: ${err.message}`, 'error');
        }
      }
    }
  }
</script>
